module.exports = __webpack_public_path__ + "img/germany-ischemic-heart-disease-male.8e05a78a.png";